import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../types';
import { ResponsiveVideo } from '../../layout';
import IconClose from '../../assets/icons/source/close.svg';
import {
  ModalStyled,
  ModalBackdrop,
  ModalWrapper,
  ModalDialog,
  ModalCloseButton,
} from './Modal.styled';

const Modal = ({
  children,
  show,
  onCloseAction,
  size,
  position,
  modalType,
  hiddenCloseButton,
  vimeoID,
  youtubeID,
  videoAutoplay,
  videoTitle,
}) => (
  <ModalStyled modifiers={show ? 'show' : 'hide'}>
    {show && (
      <ModalWrapper modifiers={position}>
        <ModalBackdrop onClick={onCloseAction} />
        <ModalDialog modifiers={[size, modalType]}>
          {hiddenCloseButton ? '' : (
            <ModalCloseButton onClick={onCloseAction}>
              <IconClose />
            </ModalCloseButton>
          )}
          {vimeoID && (
            <ResponsiveVideo>
              <iframe
                src={`https://player.vimeo.com/video/${vimeoID}?autoplay=${videoAutoplay ? '1' : '0'}&amp;title=0&amp;byline=0&amp;portrait=0`}
                frameBorder={0}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={videoTitle}
              />
            </ResponsiveVideo>
          )}
          {youtubeID && (
            <ResponsiveVideo>
              <iframe
                src={`https://www.youtube.com/embed/${youtubeID}?&autoplay=${videoAutoplay ? '1' : '0'}`}
                frameBorder={0}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={videoTitle}
              />
            </ResponsiveVideo>
          )}
          {children}
        </ModalDialog>
      </ModalWrapper>
    )}
  </ModalStyled>
);

Modal.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  onCloseAction: PropTypes.func,
  size: CustomTypes.oneOrMore(['', 'small', 'large']),
  position: CustomTypes.oneOrMore(['', 'centered']),
  modalType: CustomTypes.oneOrMore(['', 'scroll', 'video']),
  hiddenCloseButton: PropTypes.bool,
  vimeoID: PropTypes.node,
  youtubeID: PropTypes.node,
  videoAutoplay: PropTypes.bool,
  videoTitle: PropTypes.string,
};

Modal.defaultProps = {
  children: '',
  show: '',
  onCloseAction: null,
  size: '',
  position: '',
  modalType: '',
  hiddenCloseButton: null,
  vimeoID: '',
  youtubeID: '',
  videoAutoplay: null,
  videoTitle: '',
};

export default Modal;
